import { getScrollContainers, historyKey, scrollMemory } from '~/utils/scrollContainers';

// Remembers inner <main> offsets per history entry so back/forward can restore them.
export default defineNuxtPlugin(() => {
  const router = useRouter();
  let currentKey = historyKey();

  router.beforeEach(() => {
    scrollMemory.save(
      currentKey,
      getScrollContainers().map((el) => el.scrollTop),
    );
  });
  router.afterEach(() => {
    currentKey = historyKey();
  });
});
